import { connect } from "react-redux";
import BookingAside from "./BookingAside.jsx";
import { shouldEnableFlexRateChoice } from "app/pages/Booking/Quotation/flexSelectors";
import {
	checkIsCreditUsageIsEnabled,
	getAvailablePaymentTerms,
	getPartnerDepositPercentage,
} from "app/reducers/partnerSelector";
import {
	calculateCreditBasedOnQuoteBase,
	calculatePreBookTotal,
	isBookingDateEligibleForDeposit,
	isBookingEligibleForDeposit,
} from "app/pages/Booking/bookingSelectors";
import { getAvailablePaymentMethods } from "app/pages/Booking/Payment/paymentSelector";
import { isDepositEnabled } from "app/pages/.shared/Deposit/depositSelector";
import {
	getFlightOptionsStatus,
	getPrebookStatus,
	getQuoteStatus,
} from "app/pages/Booking/Quotation/quotationSelectors";
import { FLIGHT_OPTIONS_STATUS, PRE_BOOK_CODE_STATUS, QUOTATION_CODE_STATUS } from "app/constants";

const mapStateToProps = state => {
	const isCreditEnabled = checkIsCreditUsageIsEnabled(state);
	const creditsApplied = isCreditEnabled ? calculateCreditBasedOnQuoteBase(state) : 0;
	const total = calculatePreBookTotal(state) - creditsApplied;

	const quoteStatus = getQuoteStatus(state);
	const flightOptionsStatus = getFlightOptionsStatus(state);
	const prebookStatus = getPrebookStatus(state);

	const isQuoteLoading =
		quoteStatus === QUOTATION_CODE_STATUS.LOADING ||
		flightOptionsStatus === FLIGHT_OPTIONS_STATUS.LOADING;

	return {
		shop: state.shop,
		total: total,
		ficheProduit: state.ficheProduit,
		depositPercentage: getPartnerDepositPercentage(state),
		availablePaymentMethods: getAvailablePaymentMethods(state),
		enableFlexRateChoice: shouldEnableFlexRateChoice(state),
		isSubmitting: prebookStatus === PRE_BOOK_CODE_STATUS.LOADING,
		isQuoteLoading,
		availablePaymentTerms: getAvailablePaymentTerms(state),
		isBookingDateEligibleForDeposit: isBookingDateEligibleForDeposit(state),
		enableDepositDisplay: isDepositEnabled(state),
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
	};
};

export default connect(mapStateToProps)(BookingAside);
